import { RepositoryFactory } from '@/http/api/RepositoryFactory'
const PillarRepository = RepositoryFactory.get('RailwayRepository')['PillarRepository'];

import { DefaultStoreActions } from '@/store/utils/requests'
const { get, create } = DefaultStoreActions(PillarRepository)

export const STORE_MODULE_NAME = 'pillar';
export const STORE_MODULE_CONFIG =  {
    namespaced: true,
    state: {
        isVerticalMenuActive: false,
    },
    getters: {},
    mutations: {},
    actions: {
        fetch: get,
        create: create,
    },
}
